import { DOCUMENT } from '@config/constants';
import { isNil } from '@lib/Monads';
import { useMemo } from 'react';

export const isAttachmentApproved = (attachment) => {
  const isApproved = attachment.status === DOCUMENT.ANALYST_STATUS.APPROVED;

  return isApproved;
};

export const isAttachmentRejected = (attachment) => {
  const isRejected = attachment.status === DOCUMENT.ANALYST_STATUS.REJECTED;

  return isRejected;
};

export const areAttachmentsFullyRejected = (document) => {
  if (isNil(document?.attachments)) return false;
  if (document?.attachments?.length === 0) return false;

  return document
    .attachments
    .every((attachment) => isAttachmentRejected(attachment));
};

export const isAttachmentReady = (attachment) => {
  const isApproved = attachment.status === DOCUMENT.ANALYST_STATUS.APPROVED;
  const isReady = (
    attachment.storageServiceStatus === DOCUMENT.STATUS.APPROVED
    && attachment.status === DOCUMENT.ANALYST_STATUS.PENDING
  );

  return isApproved || isReady;
};

export const isDocumentReady = (document) => {
  if (isNil(document?.attachments)) return false;
  if (document?.attachments?.length === 0) return false;

  return document
    .attachments
    .some((attachment) => isAttachmentReady(attachment));
};

export const areDocumentsReady = ({ documents }) => {
  if (isNil(documents)) return false;
  if (documents.length === 0) return false;

  return documents.every((doc) => isDocumentReady(doc));
};

export const useAreDocumentsReady = ({ neededDocuments }) => {
  const ready = useMemo(() => areDocumentsReady({ documents: neededDocuments }), [neededDocuments]);

  return ready;
};

const isDocumentApproved = (document) => {
  if (isNil(document?.attachments)) return false;
  if (document?.attachments?.length === 0) return false;

  return document
    .attachments
    .some((attachment) => isAttachmentApproved(attachment));
};

export const areDocumentsApproved = ({ documents }) => {
  if (isNil(documents)) return false;
  if (documents.length === 0) return false;

  return documents.every((doc) => isDocumentApproved(doc));
};
